module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[85]206.862eefc.woff2";